import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';

export default function Admin() {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setError('');
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (user) {
      fetchSubmissions();
    }
    // eslint-disable-next-line
  }, [user]);

  const fetchSubmissions = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'contactForms'), orderBy('created', 'desc'));
      const snapshot = await getDocs(q);
      setSubmissions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      setError('Kan inzendingen niet ophalen.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Login mislukt. Controleer je gegevens.');
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <form onSubmit={handleLogin} className="card p-8 max-w-md w-full space-y-6">
          <h2 className="text-2xl font-bold mb-4 text-accent1">Admin Login</h2>
          <input type="email" placeholder="Email" className="input w-full" value={email} onChange={e => setEmail(e.target.value)} required />
          <input type="password" placeholder="Wachtwoord" className="input w-full" value={password} onChange={e => setPassword(e.target.value)} required />
          <button type="submit" className="btn-primary w-full">Inloggen</button>
          {error && <p className="text-red-600 font-semibold">{error}</p>}
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-accent1">Contactformulier Inzendingen</h1>
        <button onClick={handleLogout} className="btn-primary">Uitloggen</button>
      </div>
      {loading ? (
        <p>Inzendingen laden...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded shadow">
            <thead>
              <tr>
                <th className="px-4 py-2">Naam</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Onderwerp</th>
                <th className="px-4 py-2">Bericht</th>
                <th className="px-4 py-2">Bestand</th>
                <th className="px-4 py-2">Datum</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map(sub => (
                <tr key={sub.id} className="border-t">
                  <td className="px-4 py-2 whitespace-nowrap">{sub.name}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{sub.email}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{sub.subject}</td>
                  <td className="px-4 py-2 max-w-xs break-words">{sub.message}</td>
                  <td className="px-4 py-2">
                    {sub.fileUrl ? (
                      <a href={sub.fileUrl} target="_blank" rel="noopener noreferrer" className="text-accent1 underline">Download</a>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">{sub.created?.toDate ? sub.created.toDate().toLocaleString() : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
} 